import { Link } from "@mui/material";

import { createJsxLink } from "src/utils/create-jsx-link";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [
  {
    question: "How do I claim my tickets?",
    answer:
      "You will receive a text when the check-in window opens at 3:00 PM the day before the series begins.",
  },
  {
    question: "Do I get a ticket to each game on the schedule?",
    answer:
      "Tickets are guaranteed for the predetermined games in the pass. There are no penalties for not attending a game, however you need to confirm your attendance in order to receive a ticket. You can review your schedule on your homepage.",
  },
  {
    question: "Where are my tickets?",
    answer:
      "You will be notified tickets are available 3 hours prior to game start and are delivered within your Northwest Arkansas Naturals Account Manager.",
  },
  {
    question: "How are tickets sent to me?",
    answer:
      "3 hours prior to game start you will receive a text confirming that tickets have been delivered to your Northwest Arkansas Naturals Account Manager.",
  },
  {
    question: "Where will my seats be located?",
    answer:
      "Your Northwest Arkansas Naturals Pass is valid for the Grass Berm. Upgrades are available in other specified selections and vary by game date and availability.",
  },
  {
    question: "Can these tickets be transferred to a friend?",
    answer:
      "Northwest Arkansas Naturals Pass tickets, as well as seat upgrades and guest passes, are not eligible for resale or transfer. Abusing these guidelines can result in your Northwest Arkansas Naturals Pass being revoked.",
  },
  {
    question: "Can my seats be changed?",
    answer: (
      <>
        Once tickets have been sent to your account, they cannot be changed.
        Please contact{" "}
        <Link href="mailto:tickets@nwanaturals.com">
          tickets@nwanaturals.com
        </Link>{" "}
        for any assistance you may require.
      </>
    ),
  },
];

export const TERMS_AND_CONDITION = () => (
  <>
    By checking this box you agree to the{" "}
    {createJsxLink("Terms of Use", "https://www.attend.tech/terms-of-use")} and{" "}
    {createJsxLink("Privacy Policy", "https://www.attend.tech/privacy-policy")}.
  </>
);

export const REGISTRATION_TERMS_AND_CONDITIONS = () => (
  <>
    By checking this box you agree to receive notifications regarding offers and
    ticket delivery and agree to the{" "}
    {createJsxLink("Terms of Use", "https://www.attend.tech/terms-of-use")} and{" "}
    {createJsxLink("Privacy Policy", "https://www.attend.tech/privacy-policy")}.
  </>
);
